<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">{{ $t("reset-password.title") }}</h5>
                  <p>{{ $t("reset-password.subtitle") }}</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/logo/ct-logo.webp" alt class="img-fluid" />
              </div>
            </div>
          </div>

          <div class="card-body pt-0">
            <div v-if="showSpinner" class="spinner__div text-center p-5">
              <b-spinner type="grow"></b-spinner>
              <b-row>
                <b-col sm="12" class="text-center m-2">
                  <span><strong>{{ $t("reset-password.validating-token") }}</strong></span>
                </b-col>
              </b-row>
            </div>
            <div class="p-2 m-2" v-else>
              <form @submit.prevent="resetPassword">
                <div class="form-group">

                  <div class="form-group row mb-4">
                    <label
                    for="password"
                    class="col-form-label col-lg-4">
                    {{ $t("users.form.password") }}
                    </label>
                    <div class="col-lg-8">
                      <b-form-input
                        id="password"
                        name="password"
                        type="password"
                        v-model="$v.password.$model"
                        class="form-control"
                        :state="validateField('password')"
                      >
                      </b-form-input>
                      <password
                      class="user-create__password-meter"
                      v-model="$v.password.$model"
                      :strength-meter-only="true"
                      :secureLength="6"
                      />
                      <b-form-invalid-feedback v-if="!$v.password.required">
                        {{ $t("validation.required") }}
                      </b-form-invalid-feedback>
                      <b-form-invalid-feedback v-if="!$v.password.minLength">
                        {{ $t("validation.min-length", {length: 6}) }}
                      </b-form-invalid-feedback>
                    </div>
                  </div>

                  <div class="form-group row mb-4">
                    <label
                    for="password-repeat"
                    class="col-form-label col-lg-4">
                    {{ $t("users.form.password-repeat") }}
                    </label>
                    <div class="col-lg-8">
                      <b-form-input
                        id="password-repeat"
                        name="password-repeat"
                        type="password"
                        v-model="$v.passwordRepeat.$model"
                        class="form-control"
                        :state="validateField('passwordRepeat')"
                      >
                      </b-form-input>
                      <b-form-invalid-feedback v-if="!$v.passwordRepeat.sameAsPassword">
                        {{ $t("validation.same-passwords") }}
                      </b-form-invalid-feedback>
                    </div>
                  </div>

                </div>
                <div class="form-group row mb-0">
                  <div class="col-12 text-right">
                    <button class="btn btn-primary w-md" type="submit">
                      {{ $t("reset-password.reset-password-button") }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

      </div>
    </div>
  </Layout>
</template>

<script>
import i18n from "@/i18n";
import Password from 'vue-password-strength-meter';
import appConfig from "@/app.config";
import Layout from "@/router/layouts/auth";
import router from '@/router';
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import { authService } from '@/helpers/services/auth/authService';


/**
 * Forgot Password component
 */
export default {
  name: "ResetPassword",
  page: {
    title: i18n.t("reset-password.title"),
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, Password },
  props: {
    token: {
      type: String,
    }
  },
  data() {
    return {
      password: null,
      passwordRepeat: null,
      showSpinner: true,
    };
  },
  validations: {
    password: {
      required,
      minLength: minLength(6),
    },
    passwordRepeat: {
      sameAsPassword: sameAs('password'),
    },
  },
  methods: {
    resetPassword() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } 

      authService.resetPassword(this.password, this.token);
    },
    validateField(name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    checkToken() {
      if (!this.token) {
        router.push("/forgot-password");
      }

      this.showSpinner = true;
      authService.validateToken(this.token)
        .then(isValid => {
          if (isValid) {
            this.showSpinner = false;
          } else {
            router.push("/forgot-password");
          }
        });
    }
  },
  created() {
    this.checkToken()
  }
};
</script>

<style lang="scss" scoped>
  .spinner__div {
    text-align: center;
  }
</style>